module.exports = __webpack_public_path__ + "img/internet.4ddfd3cc.svg";